// extracted by mini-css-extract-plugin
export default {"overviewCard":"DashboardCard_overviewCard__FmxLz","svgImgWrapper":"DashboardCard_svgImgWrapper__bpdRB"};